import React from "react"
import ReactDOM from "react-dom/client"
import Login from "./Login"
import reportWebVitals from "./reportWebVitals"
import { ThemeProvider } from "styled-components"
import { GlobalStyle, theme } from "./UIKit"
import { BrowserRouter } from "react-router-dom"
import { ScrollToTop } from "./utils/utils"
import "./font.css";

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <BrowserRouter>
      <ScrollToTop />
      <Login />
    </BrowserRouter>
  </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
